import { UseProvidedAuthInterface } from "../../../hooks";
import {
  schoolCandidateRoute,
  schoolCandidateInstitutionAdminListRoute,
  SCHOOL_CANDIDATE_ROUTES,
} from "../../../routes/routes";
import { ADMIN_ROLES, INSTITUTION_ROLES } from "../pages/components/constants";

export const getSchoolCandidateNotesUrl = (pathname: string, id: number) => {
  if (pathname.includes(schoolCandidateInstitutionAdminListRoute)) {
    return SCHOOL_CANDIDATE_ROUTES.getInstitutionAdminNotesUrl(id);
  } else if (pathname.includes(schoolCandidateRoute)) {
    return SCHOOL_CANDIDATE_ROUTES.getNotesUrl(id);
  }

  return schoolCandidateRoute;
};

export const isDetailsEditVisible = (auth: UseProvidedAuthInterface) => {
  if (
    window.location.pathname.includes(schoolCandidateInstitutionAdminListRoute)
  ) {
    return [...ADMIN_ROLES, ...INSTITUTION_ROLES].includes(
      auth.currentRole?.role || 0
    );
  }

  return true;
};

export const isDetailsDeleteVisible = (auth: UseProvidedAuthInterface) => {
  if (
    window.location.pathname.includes(schoolCandidateRoute)
  ) {
    return ADMIN_ROLES.includes(
      auth.currentRole?.role || 0
    );
  }

  return true;
}
